/**
 * The Settings screens' API handle. The full write side — create/rotate/revoke
 * keys, register sources, edit the location tree, map scanners, change
 * retention, queue an erasure, invite and manage users, and read/write branding —
 * lives on the shared, session-aware data layer in {@link module:api/resources}.
 * This module is a thin hook that hands the screens that `settings` slice, so
 * every call runs through the ONE app client with its single bearer token and
 * 401-to-/login behaviour (the old module-level client had no `onUnauthorized`).
 */
import { useSession } from '../../auth/session';
import type { SettingsApi } from '../../api/resources';

export type { SettingsApi };

/** The settings API bound to the live session. */
export function useSettingsApi(): SettingsApi {
  return useSession().api.settings;
}
